/** Repository-wide sensitive-key policy for logs and generated artifacts. */
export class SensitiveDataRedactor {
    static readonly redactedValue = '[REDACTED]';
    private static readonly _sensitiveKeys = new Set([
        'password', 'currentpassword', 'newpassword', 'confirmpassword',
        'passwordhash', 'hashbase64', 'saltbase64'
    ]);
    private static _activeValues: readonly string[] = [];
    private static readonly _assignmentPattern = /((?:"|')?(?:Password|CurrentPassword|NewPassword|ConfirmPassword|PasswordHash|HashBase64|SaltBase64)(?:"|')?\s*(?::|=)\s*)("(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|[^\s,}\]]+)/gi;

    static isSensitiveKey(key: string | null | undefined): boolean {
        return !!key && SensitiveDataRedactor._sensitiveKeys.has(key.toLowerCase());
    }

    static redactText(text: string | null | undefined): string {
        if (!text) return text || '';
        let redacted = text.replace(SensitiveDataRedactor._assignmentPattern, (_match, prefix: string) =>
            `${prefix}"${SensitiveDataRedactor.redactedValue}"`);
        for (const value of SensitiveDataRedactor._activeValues) {
            if (value) redacted = redacted.split(value).join(SensitiveDataRedactor.redactedValue);
        }
        return redacted;
    }

    static beginScope(sensitiveValues: readonly string[]): { dispose(): void } {
        const previous = SensitiveDataRedactor._activeValues;
        SensitiveDataRedactor._activeValues = sensitiveValues;
        let disposed = false;
        return {
            dispose(): void {
                if (disposed) return;
                SensitiveDataRedactor._activeValues = previous;
                disposed = true;
            }
        };
    }
}
